import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatTooltipModule } from '@angular/material/tooltip';
import { HeaderComponent } from './header.component';
import { SharedModule } from '../../shared.module';

@NgModule({
  declarations: [HeaderComponent],
  imports: [CommonModule, SharedModule, MatTooltipModule],
  exports: [HeaderComponent],
})
export class HeaderModule {}
